import axios from 'axios';
import store from '../store';

export default {
      getMeetingsByEvent(eventId, coreGroupId){
        axios.get(`/api/meetings/event/${eventId}/${coreGroupId}`)
       .then(function (response){
            return response.data;
       }).catch(function (ex){
           console.error(ex);
       });
    },

    createMeeting(body){
        return new Promise((resolve, reject) => {

            axios.post('/api/meetings', body)
            .then(response => {
                resolve(response);
            }).catch(ex => {
                reject(ex);
                console.error(ex);
            })
          });

    },

    updateMeeting(id, body){
        axios.put(`/api/meetings/${id}`, body)
        .then(function (response){
            store.dispatch('fetchMeetings', store.state.personId);
            console.log(response.data);
            store.commit("toggleModal");
        }).catch(function (ex){
            console.error(ex);
        })
    },

    deleteMeeting(id){
        axios.delete(`/api/meetings/${id}`)
        .then(function (response){
            store.dispatch('fetchMeetings', store.state.personId);
            console.log(response.data);
        }).catch(function (ex){
            console.error(ex);
        })
    },

      getLocalTime(utcTime){
        if(new Date().getTimezoneOffset() < 0){
         return utcTime.add(Math.abs(new Date().getTimezoneOffset()),'minutes')
         }else{
         return utcTime.subtract(Math.abs(new Date().getTimezoneOffset()),'minutes')
         }
       }

}
